import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./home/HomePage";
import AboutPage from "./about/AboutPage";
import LocatorPage from "./locator/LocatorPage";
import Header from "./common/Header";
import Footer from "./common/Footer";
import PageNotFound from "./PageNotFound";

import PrivacyPolicy from "./notices/PrivacyPolicy";
import Slavery from "./notices/Slavery";
import TermsandConditions from "./notices/TermsandConditions";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function App() {
  return (
    <div className="container-fluid d-flex flex-column min-vh-100">
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/locator" element={<LocatorPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/slavery" element={<Slavery />} />
        <Route path="/termsandconditions" element={<TermsandConditions />} />

        <Route path="*" exact={true} element={<PageNotFound />} />
      </Routes>
      <ToastContainer autoClose={3000} hideProgressBar theme="colored" />
      <Footer version={""} />
    </div>
  );
}
